/**
 * Curated font stack enum for tenant typography.
 *
 * This is a closed list -- no free-text font input is accepted anywhere.
 * Keys must match hd-api/helpers/font_stacks.py exactly.
 */

export interface FontStack {
  key: string;
  label: string;
  css: string;
  googleFontsUrl: string | null;
}

export const FONT_STACKS: FontStack[] = [
  {
    key: "system",
    label: "System Default",
    css: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    googleFontsUrl: null,
  },
  {
    key: "inter",
    label: "Inter",
    css: "'Inter', system-ui, -apple-system, sans-serif",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap",
  },
  {
    key: "dm-sans",
    label: "DM Sans",
    css: "'DM Sans', system-ui, sans-serif",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap",
  },
  {
    key: "source-serif",
    label: "Source Serif",
    css: "'Source Serif 4', Georgia, 'Times New Roman', serif",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=Source+Serif+4:wght@400;600;700&display=swap",
  },
  {
    key: "lora",
    label: "Lora",
    css: "'Lora', Georgia, serif",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600;700&display=swap",
  },
  {
    key: "playfair",
    label: "Playfair Display",
    css: "'Playfair Display', Georgia, serif",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&display=swap",
  },
  {
    key: "raleway",
    label: "Raleway",
    css: "'Raleway', system-ui, sans-serif",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700&display=swap",
  },
];

/** Map from key to the full stack definition. */
export const FONT_STACK_MAP = new Map(FONT_STACKS.map((s) => [s.key, s]));

/** Get the CSS font-family string for a font stack key. */
export function getFontCss(key: string | null | undefined): string | null {
  if (!key) return null;
  return FONT_STACK_MAP.get(key)?.css ?? null;
}

/** Get the Google Fonts URL for a font stack key. */
export function getFontUrl(key: string | null | undefined): string | null {
  if (!key) return null;
  return FONT_STACK_MAP.get(key)?.googleFontsUrl ?? null;
}
